import React, { Component } from 'react';

class EditNotice extends Component {

    constructor(props) {
        super(props);
        this.state = { hovered: false };
    }

    toggleHoveredState(){
      this.setState({hovered: !this.state.hovered});
    }

    render() {

      const { value } = this.props;

      if(value === null)
        return null;

      if(!this.state.hovered)
      {
         return(
         <div className="EditNotice Normal" onMouseEnter={() => this.toggleHoveredState()}>
          <p>Editado</p>
         </div>
         );
      }
      else
      {
         return(
         <div onMouseLeave={() => this.toggleHoveredState()} className="EditNotice Text">
            <p>{value}</p>
         </div>
         );
      }


    }

}

export default EditNotice;
